export default "__VITE_ASSET__77e9d0ff__"